export default __webpack_public_path__ + "static/media/bedaya-logo.742836e5.png";